import React from 'react'
import IdleTimeDoughnut from '../../components/IdleTimeDoughnut/ChartWithoutControls'
import { showNotification } from '../../utils/toast.utils'
import { getIdleReasonWiseData } from '../../service/idletime.service'

const IdleTimeWrapperMachineWiseData = ({
  selectedDate,
  selectedMachine,
  selectedShift
}) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [idletimeData, setIdletimeData] = React.useState({})

  React.useEffect(() => {
    const fetchData = async (date, machine, shift) => {
      try {
        setIsLoading(true)
        const response = await getIdleReasonWiseData({
          date,
          machine,
          shift
        })

        if (response.data.success) {
          setIdletimeData(response.data.data.reasonWiseData)
        } else {
          showNotification(response.data.message, 'error')
        }
      } catch (err) {
        console.log(err)
        showNotification('Failed to fetch data', 'error')
      } finally {
        setIsLoading(false)
      }
    }

    if (selectedMachine.value !== 0 && selectedShift.value !== 0) {
      fetchData(selectedDate, selectedMachine.value, selectedShift.value)
    }
  }, [selectedDate, selectedMachine, selectedShift])

  if (isLoading) {
    return <>Loading..</>
  }

  return (
    <div>
      {idletimeData ? (
        <IdleTimeDoughnut idleTimeData={idletimeData} />
      ) : (
        <p>No data available for the selected machine and shift.</p>
      )}
    </div>
  )
}

export default IdleTimeWrapperMachineWiseData
